export default function() {
    const main = document.querySelector('main');
    const sections = main.querySelectorAll('section');
    const footer = document.querySelector('footer');

    if (sections.length > 0 && sections[sections.length - 1].classList.contains('block')) {
        footer.classList.add('pt-section');
    }
}